module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQwIDMwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmJ1cmdlciBtZW51PC90aXRsZT48cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI0MCIgaGVpZ2h0PSIzLjA1Ii8+PHJlY3QgY2xhc3M9ImNscy0xIiB5PSIxMy40NyIgd2lkdGg9IjQwIiBoZWlnaHQ9IjMuMDUiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHk9IjI2Ljk1IiB3aWR0aD0iNDAiIGhlaWdodD0iMy4wNSIvPjwvc3ZnPg=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/nav2.svg
 ** module id = 461
 ** module chunks = 0
 **/